import {
    Close
} from '@mui/icons-material';
import {
    Alert,
    Box,
    Button,
    Container,
    IconButton,
    Modal,
    Stack,
    Typography
} from '@mui/material';
import { useState } from 'react';
import ProgressTracker from '../charts/ProgressTracker';
import PointIcon from '../icons/Point';
import ImageUpload from '../inputs/ImageUpload';

const style = {
    borderRadius: 0,
    minHeight: '100vh',
    py: 4,
    gap: 2
};

const dayMappings = {
    'Monday': 1,
    'Tuesday': 2,
    'Wednesday': 3,
    'Thursday': 4,
    'Friday': 5,
};
export default function ChallengeCardInfo({ uid, cid, details, photo, setOpenChallenge, setOpen, open }) {
    const handleClose = () => {
        setOpen(false);
        setOpenChallenge(false)
    }

    const [uploadOpen, setUploadOpen] = useState(false);
    const handleUploadOpen = () => setUploadOpen(true); 
    const handleUploadClose = () => setUploadOpen(false); 
    const [error, setError] = useState(''); 
    const currentDay = new Date().getDay(); 

    const isAllowedToProceed = () => {
        if (details?.type === 'Action' || details?.day === 'Everyday') {
            return true; 
        }
        const challengeDay = dayMappings[details?.day]; 
        return currentDay === challengeDay; 
    };
    // Handle the button click
    const handleUploadClick = () => {
        if (isAllowedToProceed()) {
            setError('');  
            handleUploadOpen();  
        } else {
            setError(`This challenge can only be done on ${details?.day}.`);  // Set error message
        }
    };

    return (
        <>
        <Modal
            open={open}
            onClose={handleClose}
        >
            <Container maxWidth={'xs'} className="modal-container spread-y" sx={style} >
                <Stack spacing={2} sx={{ flex: 'auto' }}>
                    <Box sx={{ width: '100%', borderRadius: '32px 32px 0 0', aspectRatio: 2, background: `var(--light-green) url(${photo}) no-repeat center`, backgroundSize: 'cover' }} />

                    <Box className='spread-x'>
                        <Typography variant="h5">
                            { details?.title }
                        </Typography>
                        <IconButton onClick={handleClose}>
                            <Close />
                        </IconButton>
                    </Box>

                    <Box className='centered-x' sx={{ gap: 1 }}>
                        <Box className='pill centered-x'>
                            <Typography variant='caption'>
                                { details?.category }
                            </Typography>
                        </Box>

                        <Box className='pill centered-x'>
                            <Typography variant='caption'>
                                { details?.points }
                                &nbsp;
                            </Typography>
                            <PointIcon />
                        </Box>
                        
                        {
                            (details?.streakCount > 0) &&
                            <Box className='pill centered-x' sx={{ backgroundColor: 'var(--pri-yellow)' }}>
                                <Typography variant='caption'>
                                    ACTIVE STREAK
                                </Typography>
                            </Box>
                        }
                    </Box>

                    <Typography variant="body2">
                        { details?.description }
                    </Typography>
                        
                    { details?.frequencyRequired &&
                        <Typography variant="body2">
                            You need to complete this action {details.frequencyRequired} times to earn the full {details.points} points — keep the streak going!
                        </Typography>
                    }

                    { (details?.exampleSubImgs.length > 0) &&
                    <>
                        <Typography variant="subtitle2">
                            Examples of valid submissions:
                        </Typography>
                        <Box className="spread-x"  sx={{ justifyContent: 'flex-start', gap: '10px' }}>
                            {details?.exampleSubImgs?.map((img, index) => (
                                <img 
                                    key={index} 
                                    src={img} 
                                    alt={`example-img-${index}`} 
                                    className="challenge-example-image"  
                                />
                            ))}
                        </Box>
                    </>
                    }
                </Stack>
                <Stack spacing={2}>
                    <ProgressTracker 
                        dateslist={details?.datesCompleted} 
                        isStreakType={(details?.type === 'weekly' || details?.type === 'day')}
                        streakType={details?.type}
                        streakCount={details?.streakCount} 
                        streakTotal={details?.frequencyRequired} 
                    />

                    <Button className="pill_btn pri_btn" onClick={handleUploadClick}>UPLOAD IMAGE</Button>
                    {error && (
                        <Alert severity="error" sx={{ mt: 2 }}>
                            {error}
                        </Alert>
                    )}
                </Stack>
            </Container>
        </Modal>

        <ImageUpload 
            uid={uid} 
            open={uploadOpen} 
            handleClose={handleUploadClose} 
            cid={cid}
            challengeTitle={details?.title}
            challengePoints={details?.points}
            challengeType={details?.type}
            challengeFrequency={details?.frequencyRequired}
        />
        </>
    )
}